import React from 'react';
import ReactDOM from 'react-dom/client';
import './fonts';
import './index.css';
import './registerTerms';
import App from './App';
import reportWebVitals from './reportWebVitals';

//assign SRD to a variable
export const SRD = 'https://darringtonpress.com/license/';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// https://www.w3.org/TR/WCAG21/
reportWebVitals();
